<template>
  <div class="dialog" ref="dialog">
    <el-dialog :title="title" :visible.sync="dialogVisible" :append-to-body="appendToBody" :width="width" :modal="false"
      @open="onOpen" @opened="onOpened" @close="onClose" @closed="onClosed">
      <div v-if="splitLine" class="split-line"></div>
      <el-scrollbar class="dialog" v-if="scrollbar">
        <slot />
      </el-scrollbar>
      <slot v-else />
      <div slot="footer">
        <slot name="footer" />
      </div>
    </el-dialog>

    <transition name="dialog-modal-fade">
      <div v-if="modal && dialogVisible" class="v-dialog-modal" :style="[{ zIndex: zIndex }]" />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'VDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: String,
    width: String,
    modal: {
      type: Boolean,
      default: true,
    },
    scrollbar: {
      type: Boolean,
      default: true,
    },
    zIndex: {
      type: Number,
      default: 2001,
    },
    splitLine: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
    },
    dialogVisible(value) {
      this.$emit('update:visible', value)
    },
  },
  methods: {
    onOpen() {
      this.$nextTick(() => {
        let dialogWrapper = this.$refs.dialog.querySelector(
          '.el-dialog__wrapper'
        )
        dialogWrapper.style.zIndex = this.zIndex + 1
      })
      this.$emit('open')
    },
    onOpened() {
      this.$emit('opened')
    },
    onClose() {
      if (this.scrollbar) {
        let scrollbarWrapper = this.$refs.dialog.querySelector(
          '.el-scrollbar__wrap'
        )
        scrollbarWrapper.scrollTop = 0
      }
      this.$emit('close')
    },
    onClosed() {
      this.$emit('closed')
    },
  },
}
</script>

<style lang="scss" scoped>
.v-dialog-modal {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.el-scrollbar.dialog {
  width: 100%;
}

::v-deep .el-dialog__body {
  position: relative;
}

.split-line {
  position: absolute;
  top: -5px;
  left: 20px;
  right: 20px;
  border-top: 1px solid $theme-color;
}

.dialog-modal-fade-enter-active {
  -webkit-animation: dialog-modal-fade-in 0.3s;
  animation: dialog-modal-fade-in 0.3s;
}

.dialog-modal-fade-leave-active {
  -webkit-animation: dialog-modal-fade-out 0.3s;
  animation: dialog-modal-fade-out 0.3s;
}

@-webkit-keyframes dialog-modal-fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes dialog-modal-fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes dialog-modal-fade-out {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes dialog-modal-fade-out {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
